import { render, staticRenderFns } from "./gb-whatsapp-for-pc.vue?vue&type=template&id=206d0b0c&scoped=true"
import script from "./gb-whatsapp-for-pc.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-for-pc.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-for-pc.vue?vue&type=style&index=0&id=206d0b0c&prod&lang=scss&scoped=true"
import style1 from "./gb-whatsapp-for-pc.vue?vue&type=style&index=1&id=206d0b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d0b0c",
  null
  
)

export default component.exports